import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, effect, input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from 'packages/sports/common/betslip/base/services/betslip-messages-provider.service';
import { IBetslipRootState } from 'packages/sports/common/betslip/base/store/state';
import { BetslipPick } from 'packages/sports/common/betslip/core/picks/betslip-pick';
import { NavigationRouterService } from 'packages/sports/web/app/src/navigation/navigation-router.service';
import { Observable } from 'rxjs';

import { BetslipType } from '../../../../core/betslip-type';
import { PickId } from '../../../../core/picks/pick-id';
import { BETSLIP_TYPE_PROVIDER } from '../../../../digital/services/betslip-type-provider.service';
import BaseBetTypePickComponent from '../../../picks/components/digital/base-bet-type-pick.component';
import BetslipPickUtilsService from '../../../picks/services/betslip-pick-utils.service';
import PickTypeSelectorService from '../../../picks/services/pick-type-selector.service';
import { singleBetPickSelectorFactory } from '../../../single-bet/selectors';
import { ISingleBetPickState } from '../../../single-bet/state';

@Component({
    selector: 'bs-quick-bet-single-pick',
    templateUrl: './quick-bet-single-pick.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-single-pick.component.scss'],
    standalone: false,
})
export default class QuickBetSinglePickComponent extends BaseBetTypePickComponent {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() override pick: BetslipPick;
    @Input() isEpcotEnabled: boolean;
    singleBetId = input.required<PickId>();

    singleBetPickState$: Observable<ISingleBetPickState | undefined>;
    constructor(
        public sitecore: Sitecore,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) public messageProvider: IBetslipMessagesProviderService,
        @Inject(BETSLIP_TYPE_PROVIDER) public betslipType$: Observable<BetslipType>,
        protected override store: Store<IBetslipRootState>,
        pickTypeSelector: PickTypeSelectorService,
        navigationRouter: NavigationRouterService,
        redirectHelper: RedirectHelperService,
        changeDetectorRef: ChangeDetectorRef,
        betslipPickUtilsService: BetslipPickUtilsService,
        public childChangeDetectorRef: ChangeDetectorRef,
    ) {
        super(store, pickTypeSelector, messageProvider, navigationRouter, redirectHelper, changeDetectorRef, betslipPickUtilsService);
        effect(() => {
            this.singleBetPickState$ = this.store.select(singleBetPickSelectorFactory(this.singleBetId()));
            this.childChangeDetectorRef.markForCheck();
        });
    }
}
